import React, { useEffect, useRef, useState } from 'react'
import BreadCrumb from '../components/BreadCrumb'
import Container from '../components/Container'
import "../styles/clients.css";
 import Skeleton from "react-loading-skeleton";
 import 'react-loading-skeleton/dist/skeleton.css';
 import { LazyLoadImage } from "react-lazy-load-image-component";
 import "react-lazy-load-image-component/src/effects/blur.css";
import ReactPaginate from 'react-paginate';
import { getAllClients } from '../features/clients/clientSlice';
import { useDispatch, useSelector } from 'react-redux';
import loader from "../images/loader/loader1.jpg";

 

const Clients = () => {

       const servicesRef = useRef(null);
 
    const { clients, isLoading } = useSelector((state) => state.client);
      const dispatch = useDispatch();
      
      useEffect(() => {
        getclients();
      }, []);
    
      const getclients = async () => {
       
        await dispatch(getAllClients());
     
      };
    


      useEffect(() => {
        const revealElements = servicesRef.current.querySelectorAll("[data-reveal]");
    
        const scrollReveal = () => {
          for (let i = 0; i < revealElements.length; i++) {
            const elementIsInScreen =
              revealElements[i].getBoundingClientRect().top < window.innerHeight / 1.15;
    
            if (elementIsInScreen) {
              revealElements[i].classList.add("revealed");
            } else {
              revealElements[i].classList.remove("revealed");
            }
          }
        };
    
        window.addEventListener("scroll", scrollReveal);
        scrollReveal(); 
    
        return () => {
          window.removeEventListener("scroll", scrollReveal);
        };
      }, []);


      const itemsPerPage = 12;
const [currentPage, setCurrentPage] = useState(0);

const sortedClients = [...clients].sort(
  (a, b) => new Date(b.updatedAt) - new Date(a.updatedAt)
);

const pageCount = Math.ceil(sortedClients.length / itemsPerPage);
const offset = currentPage * itemsPerPage;
const currentClients = sortedClients.slice(offset, offset + itemsPerPage);

const handlePageChange = (selectedPage) => {
  setCurrentPage(selectedPage.selected);
  window.scrollTo({ top: 0, behavior: 'smooth' });  
};


const renderSkeletons = () => {
  const skeletonArray = Array.from({ length: itemsPerPage });
  return skeletonArray.map((_, index) => (
    <div className="testimonial-card" key={index}>
      <div className="testimonial-content">
        <Skeleton height={200} />
        <Skeleton height={20} width="60%" style={{ marginTop: 10 }} />
      </div>
    </div>
  ));
};

 

  return (
    <>
    <BreadCrumb title="Clients"/>
    <Container class1="clients-wrapper">
        <div className='clients-header'>
        <h3>Successful Deliveries</h3>
        </div>
<div className='clients-section' ref={servicesRef}>
  {isLoading || clients.length === 0
    ? renderSkeletons()
    : currentClients.map((item, index) => (
        <div className="testimonial-card"  key={index}>
          <div className="testimonial-content">
            <LazyLoadImage
              alt={item?.title}
              effect="blur"
              src={item.images?.[0]?.url || loader}
              placeholderSrc={loader}
              width="100%"
              height="100%"
              className="testimonial-image"
            />
                     <div className="testimonial-overlay" />           

            <h4>{item.title}</h4>

        
          </div>
        </div>
      ))}
</div>



    <div className="d-flex justify-content-center mt-4">
  <ReactPaginate
    breakLabel="..."
    nextLabel=">"
    onPageChange={handlePageChange}
    pageRangeDisplayed={2}
    marginPagesDisplayed={1}
    pageCount={pageCount}
    previousLabel="<"
    containerClassName="pagination1"
    pageLinkClassName="page-num"
    previousLinkClassName="page-num"
    nextLinkClassName="page-num"
    activeLinkClassName="active"
  />
</div>


    </Container>

    </>
  )
}

export default Clients